import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import $9f6a882f2314049c$export$2e2bcd8739ae039 from "./InsertionIndicator.mjs";
import $dzLUI$intlStringsmjs from "./intlStrings.mjs";
import "./styles.css";
import $dzLUI$styles_cssmjs from "./styles_css.mjs";
import {ListViewItem as $ae690085abfeeeb8$export$c6bde0c04b033c0e} from "./ListViewItem.mjs";
import {ListViewLayout as $f1f5a4c1b08ae7d1$export$dab781655dfbb7d3} from "./ListViewLayout.mjs";
import {ProgressCircle as $1cfe37e7feefa23d$export$c79b9d6b4cc92af7} from "../progress/ProgressCircle.mjs";
import $d49010fa0b5f14af$export$2e2bcd8739ae039 from "./RootDropIndicator.mjs";
import {DragPreview as $7e0b158902559b5b$export$905ab40ac2179daa} from "./DragPreview.mjs";
import {useDOMRef as $3c2c983d5210446c$export$c2c55ef9111cafd8} from "../utils/useDOMRef.mjs";
import {useProvider as $71dfb0e0358a12de$export$693cdb10cec23617} from "../provider/Provider.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {useGridList as $dzLUI$useGridList} from "react-aria/useGridList";
import {filterDOMProps as $dzLUI$filterDOMProps} from "react-aria/filterDOMProps";
import {FocusRing as $dzLUI$FocusRing} from "react-aria/FocusRing";
import {FocusScope as $dzLUI$FocusScope} from "react-aria/FocusScope";
import {ListKeyboardDelegate as $dzLUI$ListKeyboardDelegate} from "react-aria/ListKeyboardDelegate";
import {useListState as $dzLUI$useListState} from "react-stately/useListState";
import {mergeProps as $dzLUI$mergeProps} from "react-aria/mergeProps";
import $dzLUI$react, {useMemo as $dzLUI$useMemo, useRef as $dzLUI$useRef, useEffect as $dzLUI$useEffect, useState as $dzLUI$useState, useCallback as $dzLUI$useCallback, useContext as $dzLUI$useContext} from "react";
import {useLayoutEffect as $dzLUI$useLayoutEffect} from "react-aria/private/utils/useLayoutEffect";
import {useLocalizedStringFormatter as $dzLUI$useLocalizedStringFormatter} from "react-aria/useLocalizedStringFormatter";
import {Virtualizer as $dzLUI$Virtualizer} from "react-aria/private/virtualizer/Virtualizer";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 






















const $9710157b2ac3a032$export$870039b0abfe3de0 = /*#__PURE__*/ (0, $dzLUI$react).createContext(null);
const $9710157b2ac3a032$var$ROW_HEIGHTS = {
    compact: {
        medium: 32,
        large: 40
    },
    regular: {
        medium: 40,
        large: 50
    },
    spacious: {
        medium: 48,
        large: 60
    }
};
function $9710157b2ac3a032$var$useListLayout(state, density, overflowMode) {
    let { scale: scale } = (0, $71dfb0e0358a12de$export$693cdb10cec23617)();
    let layout = (0, $dzLUI$useMemo)(()=>new (0, $f1f5a4c1b08ae7d1$export$dab781655dfbb7d3)({
            estimatedRowHeight: $9710157b2ac3a032$var$ROW_HEIGHTS[density || 'regular'][scale]
        }), [
        scale,
        density,
        overflowMode
    ]);
    return layout;
}
const $9710157b2ac3a032$export$84d0dd190d551cd1 = /*#__PURE__*/ (0, $dzLUI$react).forwardRef(function ListView(props, ref) {
    let { density: density = 'regular', loadingState: loadingState, onLoadMore: onLoadMore, isQuiet: isQuiet, overflowMode: overflowMode = 'truncate', onAction: onAction, dragAndDropHooks: dragAndDropHooks, renderEmptyState: renderEmptyState, ...otherProps } = props;
    let isListDraggable = !!dragAndDropHooks?.useDraggableCollectionState;
    let isListDroppable = !!dragAndDropHooks?.useDroppableCollectionState;
    let dragHooksProvided = (0, $dzLUI$useRef)(isListDraggable);
    let dropHooksProvided = (0, $dzLUI$useRef)(isListDroppable);
    (0, $dzLUI$useEffect)(()=>{
        if (dragHooksProvided.current !== isListDraggable && process.env.NODE_ENV !== 'production') console.warn('Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
        if (dropHooksProvided.current !== isListDroppable && process.env.NODE_ENV !== 'production') console.warn('Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior.');
    }, [
        isListDraggable,
        isListDroppable
    ]);
    let domRef = (0, $3c2c983d5210446c$export$c2c55ef9111cafd8)(ref);
    let state = (0, $dzLUI$useListState)({
        ...props,
        selectionBehavior: props.selectionStyle === 'highlight' ? 'replace' : 'toggle'
    });
    let { collection: collection, selectionManager: selectionManager } = state;
    let isLoading = loadingState === 'loading' || loadingState === 'loadingMore';
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(props);
    let dragState = null;
    let preview = (0, $dzLUI$useRef)(null);
    if (isListDraggable && dragAndDropHooks) {
        dragState = dragAndDropHooks.useDraggableCollectionState({
            collection: collection,
            selectionManager: selectionManager,
            preview: preview
        });
        dragAndDropHooks.useDraggableCollection({}, dragState, domRef);
    }
    let layout = $9710157b2ac3a032$var$useListLayout(state, props.density || 'regular', overflowMode);
    let DragPreview = dragAndDropHooks?.DragPreview;
    let dropState = null;
    let droppableCollection = null;
    let isRootDropTarget = false;
    if (isListDroppable && dragAndDropHooks) {
        dropState = dragAndDropHooks.useDroppableCollectionState({
            collection: collection,
            selectionManager: selectionManager
        });
        droppableCollection = dragAndDropHooks.useDroppableCollection({
            keyboardDelegate: new (0, $dzLUI$ListKeyboardDelegate)({
                collection: collection,
                disabledKeys: dragState?.draggingKeys.size ? undefined : selectionManager.disabledKeys,
                ref: domRef,
                layoutDelegate: layout
            }),
            dropTargetDelegate: layout
        }, dropState, domRef);
        isRootDropTarget = dropState.isDropTarget({
            type: 'root'
        });
    }
    let { gridProps: gridProps } = (0, $dzLUI$useGridList)({
        ...props,
        isVirtualized: true,
        layoutDelegate: layout,
        onAction: onAction
    }, state, domRef);
    let focusedKey = selectionManager.focusedKey;
    let dropTargetKey = null;
    if (dropState?.target?.type === 'item') {
        dropTargetKey = dropState.target.key;
        if (dropState.target.dropPosition === 'after') // Normalize to the "before" drop position since we only render those in the DOM.
        dropTargetKey = state.collection.getKeyAfter(dropTargetKey) ?? dropTargetKey;
    }
    let persistedKeys = (0, $dzLUI$useMemo)(()=>{
        return new Set([
            focusedKey,
            dropTargetKey
        ].filter((k)=>k !== null));
    }, [
        focusedKey,
        dropTargetKey
    ]);
    // wait for layout to get accurate measurements
    let [isVerticalScrollbarVisible, setVerticalScollbarVisible] = (0, $dzLUI$useState)(false);
    let [isHorizontalScrollbarVisible, setHorizontalScollbarVisible] = (0, $dzLUI$useState)(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $dzLUI$useLayoutEffect)(()=>{
        if (domRef.current) {
            // 2 is the width of the border which is not part of the box size
            setVerticalScollbarVisible(domRef.current.clientWidth + 2 < domRef.current.offsetWidth);
            setHorizontalScollbarVisible(domRef.current.clientHeight + 2 < domRef.current.offsetHeight);
        }
    });
    let hasAnyChildren = (0, $dzLUI$useMemo)(()=>[
            ...collection
        ].some((item)=>item.hasChildNodes), [
        collection
    ]);
    return /*#__PURE__*/ (0, $dzLUI$react).createElement($9710157b2ac3a032$export$870039b0abfe3de0.Provider, {
        value: {
            state: state,
            dragState: dragState,
            dropState: dropState,
            dragAndDropHooks: dragAndDropHooks,
            onAction: onAction,
            isListDraggable: isListDraggable,
            isListDroppable: isListDroppable,
            layout: layout,
            loadingState: loadingState,
            renderEmptyState: renderEmptyState
        }
    }, /*#__PURE__*/ (0, $dzLUI$react).createElement((0, $dzLUI$FocusScope), null, /*#__PURE__*/ (0, $dzLUI$react).createElement((0, $dzLUI$FocusRing), {
        focusRingClass: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($dzLUI$styles_cssmjs))), 'focus-ring')
    }, /*#__PURE__*/ (0, $dzLUI$react).createElement((0, $dzLUI$Virtualizer), {
        ...(0, $dzLUI$mergeProps)(isListDroppable ? droppableCollection?.collectionProps : null, gridProps),
        ...(0, $dzLUI$filterDOMProps)(otherProps),
        ...gridProps,
        ...styleProps,
        onScroll: undefined,
        isLoading: isLoading,
        onLoadMore: onLoadMore,
        ref: domRef,
        persistedKeys: persistedKeys,
        scrollDirection: "vertical",
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($dzLUI$styles_cssmjs))), 'react-spectrum-ListView', `react-spectrum-ListView--${density}`, 'react-spectrum-ListView--emphasized', {
            'react-spectrum-ListView--quiet': isQuiet,
            'react-spectrum-ListView--loadingMore': loadingState === 'loadingMore',
            'react-spectrum-ListView--draggable': !!isListDraggable,
            'react-spectrum-ListView--dropTarget': !!isRootDropTarget,
            'react-spectrum-ListView--isVerticalScrollbarVisible': isVerticalScrollbarVisible,
            'react-spectrum-ListView--isHorizontalScrollbarVisible': isHorizontalScrollbarVisible,
            'react-spectrum-ListView--hasAnyChildren': hasAnyChildren,
            'react-spectrum-ListView--wrap': overflowMode === 'wrap'
        }, styleProps.className),
        layout: layout,
        layoutOptions: (0, $dzLUI$useMemo)(()=>({
                isLoading: isLoading
            }), [
            isLoading
        ]),
        collection: collection
    }, (0, $dzLUI$useCallback)((type, item)=>{
        if (type === 'item') return /*#__PURE__*/ (0, $dzLUI$react).createElement($9710157b2ac3a032$var$Item, {
            item: item
        });
        else if (type === 'loader') return /*#__PURE__*/ (0, $dzLUI$react).createElement($9710157b2ac3a032$var$LoadingView, null);
        else if (type === 'placeholder') return /*#__PURE__*/ (0, $dzLUI$react).createElement($9710157b2ac3a032$var$EmptyState, null);
    }, [])))), DragPreview && isListDraggable && dragAndDropHooks && dragState && /*#__PURE__*/ (0, $dzLUI$react).createElement(DragPreview, {
        ref: preview
    }, ()=>{
        if (dragState.draggedKey == null) return null;
        if (dragAndDropHooks.renderPreview) return dragAndDropHooks.renderPreview(dragState.draggingKeys, dragState.draggedKey);
        let item = state.collection.getItem(dragState.draggedKey);
        if (!item) return null;
        let itemCount = dragState.draggingKeys.size;
        let itemHeight = layout.getLayoutInfo(dragState.draggedKey)?.rect.height ?? 0;
        return /*#__PURE__*/ (0, $dzLUI$react).createElement((0, $7e0b158902559b5b$export$905ab40ac2179daa), {
            item: item,
            itemCount: itemCount,
            itemHeight: itemHeight,
            density: density
        });
    }));
});
function $9710157b2ac3a032$var$Item({ item: item }) {
    let { isListDroppable: isListDroppable, state: state, onAction: onAction } = (0, $dzLUI$useContext)($9710157b2ac3a032$export$870039b0abfe3de0);
    return /*#__PURE__*/ (0, $dzLUI$react).createElement((0, $dzLUI$react).Fragment, null, isListDroppable && state.collection.getKeyBefore(item.key) == null && /*#__PURE__*/ (0, $dzLUI$react).createElement((0, $d49010fa0b5f14af$export$2e2bcd8739ae039), {
        key: "root"
    }), isListDroppable && /*#__PURE__*/ (0, $dzLUI$react).createElement((0, $9f6a882f2314049c$export$2e2bcd8739ae039), {
        key: `${item.key}-before`,
        target: {
            key: item.key,
            type: 'item',
            dropPosition: 'before'
        }
    }), /*#__PURE__*/ (0, $dzLUI$react).createElement((0, $ae690085abfeeeb8$export$c6bde0c04b033c0e), {
        item: item,
        isEmphasized: true,
        hasActions: !!onAction
    }), isListDroppable && /*#__PURE__*/ (0, $dzLUI$react).createElement((0, $9f6a882f2314049c$export$2e2bcd8739ae039), {
        key: `${item.key}-after`,
        target: {
            key: item.key,
            type: 'item',
            dropPosition: 'after'
        },
        isPresentationOnly: state.collection.getKeyAfter(item.key) != null
    }));
}
function $9710157b2ac3a032$var$LoadingView() {
    let { state: state } = (0, $dzLUI$useContext)($9710157b2ac3a032$export$870039b0abfe3de0);
    let stringFormatter = (0, $dzLUI$useLocalizedStringFormatter)((0, ($parcel$interopDefault($dzLUI$intlStringsmjs))), '@react-spectrum/list');
    return /*#__PURE__*/ (0, $dzLUI$react).createElement($9710157b2ac3a032$var$CenteredWrapper, null, /*#__PURE__*/ (0, $dzLUI$react).createElement((0, $1cfe37e7feefa23d$export$c79b9d6b4cc92af7), {
        isIndeterminate: true,
        "aria-label": state.collection.size > 0 ? stringFormatter.format('loadingMore') : stringFormatter.format('loading')
    }));
}
function $9710157b2ac3a032$var$EmptyState() {
    let { renderEmptyState: renderEmptyState } = (0, $dzLUI$useContext)($9710157b2ac3a032$export$870039b0abfe3de0);
    let emptyState = renderEmptyState ? renderEmptyState() : null;
    if (emptyState == null) return null;
    return /*#__PURE__*/ (0, $dzLUI$react).createElement($9710157b2ac3a032$var$CenteredWrapper, null, emptyState);
}
function $9710157b2ac3a032$var$CenteredWrapper({ children: children }) {
    let { state: state } = (0, $dzLUI$useContext)($9710157b2ac3a032$export$870039b0abfe3de0);
    return /*#__PURE__*/ (0, $dzLUI$react).createElement("div", {
        role: "row",
        "aria-rowindex": state.collection.size + 1,
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($dzLUI$styles_cssmjs))), 'react-spectrum-ListView-centeredWrapper', {
            'react-spectrum-ListView-centeredWrapper--loadingMore': state.collection.size > 0
        })
    }, /*#__PURE__*/ (0, $dzLUI$react).createElement("div", {
        role: "gridcell"
    }, children));
}


export {$9710157b2ac3a032$export$870039b0abfe3de0 as ListViewContext, $9710157b2ac3a032$export$84d0dd190d551cd1 as ListView};
//# sourceMappingURL=ListView.mjs.map
